<template>
    <div class="col-12">
        <fieldset style="border: 1px solid #dae0e5; padding: 10px;">
            <legend>Documents</legend>
            <vue-tree-list
                :model="treeDocuments"
                default-tree-node-name="new folder"
                default-leaf-node-name="new file"
                v-bind:default-expanded="false"
                ref="document_list"
            >
                <template v-slot:leafNameDisplay="slotProps">
                <span v-if="slotProps.model.isLeaf">
                    &nbsp;<a target="_blank" :href="slotProps.model.hasOwnProperty('url') ? slotProps.model.url : '#'">{{
                        slotProps.model.name
                    }}</a>
                </span>
                    <span v-else>
                  &nbsp;{{ slotProps.model.name }}
                </span>
                </template>

                <template v-slot:leafNodeIcon="slotProps">
                <span class="icon p-2">
                   <i :class="slotProps.model.hasOwnProperty('icon') ? slotProps.model.icon : 'fa fa-file'"></i>
                </span>
                </template>

                <span class="icon p-2" title="Add new Folder" slot="addTreeNodeIcon"><i
                    class="fa fa-folder text-warning"></i></span>

                <template v-slot:addLeafNodeIcon="slotProps">
             <span v-if="slotProps.model.type === 'folder'" @click.prevent.stop="() => {}"
                   class="icon p-2" slot="addLeafNodeIcon"
                   title="Priority"><i
                 class="fa fa-lock text-secondary"></i></span>

                    <span @click.prevent.stop="() => {}" class="icon p-2" slot="addLeafNodeIcon"
                          title="Add new document"><i
                        class="fa fa-upload text-success"></i></span>
                </template>
                <span class="icon p-2" slot="editNodeIcon"><i class="fa fa-edit text-info"></i></span>

                <template v-slot:delNodeIcon="slotProps">
                <span @click.prevent.stop="onDel(slotProps.model)" class="icon p-2" slot="delNodeIcon"
                      title="Delete"><i class="fa fa-trash text-danger"></i></span>
                </template>

                <template v-slot:treeNodeIcon="slotProps">
                    <span class="fa fa-folder text-warning"></span>
                </template>

                <span class="icon p-2" slot="treeNodeIcon"><i class="fa fa-folder text-warning"></i></span>
            </vue-tree-list>
        </fieldset>
    </div>
</template>

<script>
import {monthNames, URL_BASE, years} from '../../../utils/helper';
import {VueTreeList, Tree, TreeNode} from 'vue-tree-list-new'

export default {
    name: "DocumentsComponent",
    components: {
        VueTreeList,
    },
    props: {
        folders: {
            default() {
                return []
            }
        }

    },
    data: function () {
        return {
            file: null,
            items: [],
            collection: [],
            monthNames: [],
            newTree: {},
            isLoading: false,
            treeDocuments: new Tree([]),
            timer: null,
            waitTime: 600,
            nodeEditing: null,
            folder: null,
            templateColumns: [
                {
                    label: 'Name',
                    field: 'name',
                },
                {
                    label: 'Actions',
                    field: 'actions',
                }
            ],
            templateRows: []
        }
    },
    async mounted() {
        await this.getData()
    },
    methods: {
        async getData() {
            this.isLoading = true;
            let response = await axios.get(`/word/documents/static/structure`)
            let dataTree = response.data.data;
            this.treeDocuments = new Tree(dataTree);
            this.isLoading = false;
        },

         onDel(node) {
            if (confirm('Are you sure?')) {
                 axios.post(`/word/documents/static/delete/`, {
                    file: node.id
                }).then(() => {
                     this.getData();
                 })
            }
        },

    }
}
</script>

<style>
.vtl-icon-edit {
    display: none;

}

.vs__selected-options {
    flex-wrap: nowrap;
}

.icon:hover {
    cursor: pointer;
}
</style>
